import React from "react"
import { css } from "@emotion/css"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import Badges from "./Badges"
import Buttons from "./Buttons"
import TotalPrice from "./TotalPrice"
import * as styles from "../../newStyles.module.scss"
import { TariffText } from "@features/Price/Panel/Tariff/types"

interface TariffProps {
  text: TariffText
  buttons?: boolean
  show?: boolean
}

interface WithTooltipProps {
  text: string
  description?: string
}

const Tariff: React.FC<TariffProps> = ({ text, buttons = true, show = true }) => {
  const handleButtonClick = () => {
    carrotquest.track(text.buttonClickEventText, {})
  }

  return (
    <div>
      {show && text.work && <p className={styles.tariffDescription}>{text.work}</p>}

      <div className={`${styles.tariffHeader} ${show ? "" : ""}`}>
        <Badges tariff={text.name} isFixed={show} />
        <h4 className={styles.tariffTitle}>{text.title}</h4>
      </div>

      <TotalPrice tariff={text.name} />

      {buttons && <Buttons tariff={text.name} trackOnClick={handleButtonClick} />}

      {show && (
        <ul className={styles.tariffOptionsList}>
          <WithTooltip text={text.options[0]} description={text.options[1]} />
          <WithTooltip text={text.options[2]} description={text.options[3]} />

          <hr className={`${hrCss}`} />

          {text.options.slice(4).map((option, index) => {
            if (option === "divider") {
              return null
            }

            return <li key={index} className={styles.tariffOptionItem} dangerouslySetInnerHTML={{ __html: option }} />
          })}
        </ul>
      )}
    </div>
  )
}

interface WithTooltipProps {
  text: string
  name?: any
  description?: string
  className?: string
}

export const WithTooltip: React.FC<WithTooltipProps> = ({ text, description, className }) => (
  <li
    className={`
			${styles.withTooltipItem}
			${className ?? ""}
			${!className ? "" : ""}
		`}
  >
    <OverlayTrigger
      overlay={
        <Tooltip>
          <span dangerouslySetInnerHTML={{ __html: description ?? "" }} />
        </Tooltip>
      }
    >
      <span dangerouslySetInnerHTML={{ __html: text }} />
    </OverlayTrigger>
  </li>
)

const hrCss = css`
  opacity: 1;
  color: #f0eef4;
  margin: 24px 0;
`

export default Tariff
